import type { LinkedSessionQuery } from 'services/KicodeService';
import { blockResourcePath } from 'ts-components/PiChat/kicodeSessions';

/** A new block (no dashlet yet) has nothing linked. */
export const blockResumeQuery = (
  dashboardId: string,
  dashletId: string | undefined,
  employeeId: string | null | undefined
): LinkedSessionQuery | null =>
  dashletId && employeeId
    ? {
        resourcePath: blockResourcePath(dashboardId, dashletId),
        builder: 'block',
        createdBy: employeeId,
      }
    : null;

interface PanelIds {
  dashletId?: string;
  conversationId?: string;
}

/**
 * The resolved id applies to the ids the panel opened with. Once a push
 * reports different ids, those are newer than anything the lookup returned.
 */
export const pickPanelConversationId = (
  opened: PanelIds,
  current: PanelIds,
  resolved: string | null
): string | undefined =>
  current.dashletId === opened.dashletId &&
  current.conversationId === opened.conversationId
    ? resolved ?? undefined
    : current.conversationId;
